import { render, staticRenderFns } from "./StartSessionModal.vue?vue&type=template&id=3b077a0f&"
import script from "./StartSessionModal.vue?vue&type=script&lang=ts&"
export * from "./StartSessionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports